import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { memo, useEffect, useState } from "react";
import { useThemes } from "../Theme/theme";

function GSTR3BTable4({ data }) {
  const { theme } = useThemes()
  const [state, setState] = useState([])



  useEffect(() => {
    if (data[0]?.GSTR2Data) {
      GSTR3B4FilterData()
    }

  }, [data])



  function GSTR3B4FilterData() {
    let exemptIntraStateSum = 0;
    let exemptInterStateSum = 0;

    let NONIntraStateSum = 0;
    let NONInterStateSum = 0;

    const GSTR3BPurchase = data[0]?.GSTR2Data;

    GSTR3BPurchase.forEach((purchase) => {
      purchase.relatedpurchaselineitems.forEach((lineItem) => {
        lineItem.relateditemmaster.forEach((item) => {
          if (item.taxabilitycd === 2) {
            // Find the corresponding GST rate for this line item
            let lineItemTotal = 0;
            if (
              purchase.relatedpartymaster[0]?.country === "IndiaState" &&
              purchase?.relatedpartymaster[0]?.placeofsupply !== null &&
              purchase?.placeofsupply !== null &&
              purchase?.relatedpartymaster[0]?.placeofsupply ===
              purchase?.placeofsupply
            ) {
              lineItemTotal = lineItem.itemrate * lineItem.itemquantity;
              exemptIntraStateSum += lineItemTotal;
            } else if (
              purchase.relatedpartymaster[0]?.country === "IndiaState" &&
              purchase?.relatedpartymaster[0]?.placeofsupply !== null &&
              purchase?.placeofsupply !== null &&
              purchase?.relatedpartymaster[0]?.placeofsupply !==
              purchase?.placeofsupply
            ) {
              lineItemTotal = lineItem.ItemRate * lineItem.itemquantity;
              exemptInterStateSum += lineItemTotal;
            }
          }

          if (item.taxabilitycd === 10) {
            // Find the corresponding GST rate for this line item
            let lineItemTotal = 0;
            if (
              purchase.relatedpartymaster[0]?.country === "IndiaState" &&
              purchase?.relatedpartymaster[0]?.placeofsupply !== null &&
              purchase?.placeofsupply !== null &&
              purchase?.relatedpartymaster[0]?.placeofsupply ===
              purchase?.placeofsupply
            ) {
              lineItemTotal = lineItem.itemrate * lineItem.itemquantity;
              NONIntraStateSum += lineItemTotal;
            } else if (
              purchase.relatedpartymaster[0]?.country === "IndiaState" &&
              purchase?.relatedpartymaster[0]?.placeofsupply !== null &&
              purchase?.placeofsupply !== null &&
              purchase?.relatedpartymaster[0]?.placeofsupply !==
              purchase?.placeofsupply
            ) {
              lineItemTotal = lineItem.itemrate * lineItem.itemquantity;
              NONInterStateSum += lineItemTotal;
            }
          }
        });
      });
    });
    const result = [
      {
        taxabillity: "exempt",
        interstateSum: exemptInterStateSum,
        intraStateSum: exemptIntraStateSum,
      },
      {
        taxabillity: "NONTaxable",
        interstateSum: NONInterStateSum,
        intraStateSum: NONIntraStateSum,
      },
    ];
    setState(result);
  }

  const headCells = [
    {
      id: "1",
      label: "Nature of supplies",
      minWidht: 170,
    },
    {
      id: "3",
      label: "Inter-state supplies",
      minWidht: 120,
    },
    {
      id: "4",
      label: "Intra-state supplies",
      minWidht: 120,
    },
  ];
  const natureOfSupplies = [
    "From a supplier under composition scheme, Exempt  and Nil rated supply",
    "Non GST supply",
  ];
  return (
    <>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          marginTop: 3,
        }}
      >
        <Typography sx={{ paddingX: 1 }}>
          4. Details of exempt, nil-rated and non-GST inward supplies
        </Typography>
        <TableContainer
          sx={{
            maxHeight: 400,
            m: 1,
            "::-webkit-scrollbar": {
              width: 14,
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888",
            },
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              width: "100%",
              borderRadius: 2,
              maxHeight: 440,
              backgroundColor: "#f9f9fe",
            }}
          >
            <TableHead
              sx={{
                height: 12,
              }}
            >
              <TableRow>
                {headCells?.map((column) => (
                  <TableCell
                    align="center"
                    sx={{
                      color: "#FFF",
                      backgroundColor: theme.palette.secondary.main,
                      fontFamily: "overpass",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                    key={column.id}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {natureOfSupplies.map((items, index) => {
                return (
                  <>
                    <TableRow>
                      <TableCell>{items}</TableCell>
                      <TableCell align="center">
                        {data[index]?.interstateSum}
                      </TableCell>
                      <TableCell align="center">
                        {data[index]?.intraStateSum}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

export default memo(GSTR3BTable4);
